import { Avatar } from '@vivaldis/antd-ui'
import { UserOutlined } from '@ant-design/icons'
import { useUser } from '@vivaldis/session'

export const CompanyAvatar = () => {
  const user = useUser()
  return (
    <Avatar
      size="large"
      icon={<UserOutlined />}
      src={user?.company?.logo}
      style={{ marginRight: 8 }}
    />
  )
}
